function hasClass(elem, className) {
    return elem.className.split(' ').indexOf(className) > -1;
}

if(typeof(document.querySelector('[data-popup]')) != 'undefined' && document.querySelector('[data-popup]') != null) {

    // Create popup
    document.addEventListener('click', function (e) {
        var popupTrigger = e.target.hasAttribute('data-popup');

        if (popupTrigger === true) {
            e.preventDefault();
            let popupLink = document.querySelector('[data-popup]').getAttribute('data-popup');
            let popup = document.createElement("section");

            popup.className = 'popup';
            popup.innerHTML = '' +
                '<div class="popup__close" data-clickable>' +
                    '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon__close" preserveAspectRatio="xMinYMin" viewBox="-6 -6 24 24"><path style="fill: currentColor;" d="M7.314 5.9l3.535-3.536A1 1 0 109.435.95L5.899 4.485 2.364.95A1 1 0 10.95 2.364l3.535 3.535L.95 9.435a1 1 0 101.414 1.414l3.535-3.535 3.536 3.535a1 1 0 101.414-1.414L7.314 5.899z"/></svg>' +
                '</div>' +
                '<div class="popup__content">' +
                    '<img src="' + popupLink + '" alt="" />' +
                '</div>';
            document.body.appendChild(popup);
        }
    });

    // Remove current popup
    document.addEventListener('click', function (e) {
        if (hasClass(e.target, 'popup__close')) {
            var parentPopup = getClosest(e.target, '.popup');
            parentPopup.remove();
        }
    }, false);
}
